export const voucherIdFromQuery = value => {
  if (!/^[1-9]\d*$/.test(String(value ?? "")) || Array.isArray(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
};

export const voucherConfigurationRoute = id => {
  const voucherId = voucherIdFromQuery(id);
  return voucherId ? { path: "/comprobantes", query: { voucherId: String(voucherId) } } : null;
};
